import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { testimonials, siteInfo } from '@/mocks/manhwa';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="min-h-screen pt-16">
        <div className="bg-background-100 border-b border-background-200">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">
                首页
              </Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>

            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              关于虚空韩漫网
            </h1>
            <p className="text-sm text-foreground-500 max-w-2xl">
              致力于为中文读者提供最优质的韩国漫画在线阅读体验
            </p>
          </div>
        </div>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    虚空韩漫网成立于{siteInfo.founded}，是一家专注于韩国漫画在线阅读的中文平台。我们致力于为中文读者提供高品质、流畅的韩漫阅读体验，聚合了韩国漫画网免费在线观看的韩国漫画，资源整合能力强。
                  </p>
                  <p>
                    目前平台收录超过{siteInfo.totalManhwa}部韩国漫画作品，涵盖浪漫爱情、奇幻冒险、热血动作、悬疑惊悚、搞笑日常、剧情人生等多种题材分类，满足不同读者的喜好和需求。
                  </p>
                  <p>
                    我们拥有专业的运营团队，每日实时同步最新韩漫更新，确保读者能在第一时间阅读到最新的章节内容。日均访问用户超过{siteInfo.dailyVisitors}，已成为中文韩漫爱好者最信赖的阅读平台之一。
                  </p>
                  <p>
                    虚空韩漫网的使命是——打破语言壁垒，让每一位中文读者都能轻松享受韩国漫画的魅力。我们将持续优化阅读体验，扩充漫画资源，为您带来更好的服务。
                  </p>
                </div>

                <div className="grid grid-cols-3 gap-6 mt-8">
                  <div className="text-center p-4 bg-primary-50 rounded-lg">
                    <div className="text-2xl font-bold text-primary-600">{siteInfo.totalManhwa}</div>
                    <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
                  </div>
                  <div className="text-center p-4 bg-accent-50 rounded-lg">
                    <div className="text-2xl font-bold text-accent-600">{siteInfo.dailyVisitors}</div>
                    <div className="text-xs text-foreground-500 mt-1">日访问用户</div>
                  </div>
                  <div className="text-center p-4 bg-secondary-50 rounded-lg">
                    <div className="text-2xl font-bold text-secondary-600">8大</div>
                    <div className="text-xs text-foreground-500 mt-1">分类题材</div>
                  </div>
                </div>
              </div>

              <div className="relative aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20reading%20nook%20with%20a%20tablet%20displaying%20colorful%20webtoon%20art%2C%20surrounded%20by%20books%20and%20a%20warm%20lamp%2C%20soft%20natural%20light%20from%20window%2C%20comfortable%20atmosphere%2C%20Korean%20aesthetic%20interior%2C%20minimalist%20style%2C%20warm%20neutral%20tones&width=800&height=600&seq=about-brand-image&orientation=landscape"
                  alt="虚空韩漫网品牌形象"
                  className="w-full h-full object-cover"
                  title="虚空韩漫网品牌形象"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-500 mt-2">
                听听读者们怎么说
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((t) => (
                <div
                  key={t.id}
                  className="bg-background-50 rounded-lg border border-background-200/70 p-6"
                >
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    &ldquo;{t.comment}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-full h-full object-cover"
                        title={t.name}
                      />
                    </div>
                    <span className="text-sm font-medium text-foreground-800">{t.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-500 mt-2">
                  有任何问题或建议，欢迎联系我们
                </p>
              </div>

              <div className="bg-background-100 rounded-xl border border-background-200/70 p-8">
                <div className="space-y-5">
                  <div className="flex items-center gap-4">
                    <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </span>
                    <div>
                      <div className="text-xs text-foreground-500">电子邮箱</div>
                      <div className="text-sm font-medium text-foreground-800">{siteInfo.email}</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-time-line text-lg"></i>
                    </span>
                    <div>
                      <div className="text-xs text-foreground-500">工作时间</div>
                      <div className="text-sm font-medium text-foreground-800">每日 9:00 - 22:00</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                      <i className="ri-global-line text-lg"></i>
                    </span>
                    <div>
                      <div className="text-xs text-foreground-500">官方网站</div>
                      <div className="text-sm font-medium text-foreground-800">www.xkmanhua.com</div>
                    </div>
                  </div>
                </div>

                <div className="mt-8 pt-6 border-t border-background-200">
                  <h3 className="font-heading text-sm font-semibold text-foreground-800 mb-3">
                    版权声明
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    虚空韩漫网所展示的所有漫画内容均来自互联网，版权归原作者及出版社所有。如涉及版权问题，请及时联系我们，我们将第一时间处理。我们尊重知识产权，致力于为读者提供合法合规的阅读服务。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于虚空韩漫网',
            description:
              '虚空韩漫网是一家专注于韩国漫画在线阅读的中文平台，致力于为中文读者提供高品质、流畅的韩漫阅读体验。',
            url: 'https://www.xkmanhua.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '虚空韩漫网',
              url: 'https://www.xkmanhua.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.xkmanhua.com/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}